import {Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import * as EXIF from 'exif-js';
import {LexiboxService, SearchLexiboxService} from '../../_services';
import {first} from 'rxjs/operators';
import {Category, Intercalaire, LexiboxImage, SubCategory, Word} from '../../_models';
import {config} from '../../../assets/config';
import {WordService} from '../../_services/word.service';
import {getCurrentAbeille} from '../../../assets/utils.js';
import {HttpClient} from '@angular/common/http';
import {NgxPicaErrorInterface, NgxPicaService} from 'ngx-pica';

@Component({
    selector: 'app-create-word',
    templateUrl: './create-word.component.html',
    styleUrls: ['./create-word.component.scss']
})
export class CreateWordComponent {

    @Input() word: Word;
    @Input() intercalaireId: string;
    @Input() category: Category;
    @Input() subCategory: SubCategory;
    @Output() refreshEvent = new EventEmitter<string>();
    @ViewChild('search', {static: false}) searchField: ElementRef;
    @ViewChild('importInput', {static: false}) importInput: ElementRef;

    patientId = '';
    wordForm = new FormGroup({
        wordWritten: new FormControl(''),
    });
    apiUrl = config.apiUrl;
    showTabs = -1;
    explorerTab = '';
    files: any = [];
    currentDownloadingFile = 0;
    uploading = false;
    iOS = false;

    /* vocal word variables*/
    isRecording = false;
    audioBlob = null;
    audioUrl = null;
    audioString = null;

    searchResults: any[] = [];
    exploreMainPicture = true;
    imageOrientation = 1;
    mainFile = {exist: false, element: {}, type: '', thumb: ''};

    /*image databases*/
    activateLexibox = true;
    activateIcons8 = true;
    activatePixabay = true;

    constructor(private wordService: WordService,
                private searchLexibox: SearchLexiboxService,
                private lexiboxService: LexiboxService,
                private ngxPicaService: NgxPicaService,
                private http: HttpClient) {
        this.patientId = getCurrentAbeille().id;
        this.iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

    }


    ngOnChanges(changes: SimpleChanges) {

        this.audioUrl = null;
        this.audioString = '';
        this.files = [];

        if (this.word) {
            this.wordForm = new FormGroup({
                wordWritten: new FormControl(this.word.name),
            });

            this.mainFile = {exist: true, element: {picture: this.word.fileName}, type: 'image', thumb: this.word.fileName};

            this.wordService.getAdditionalFiles(this.word.id).pipe(first()).subscribe(files => {
                (files as any[]).map(file => {
                    this.files.push({exist: true, element: {url: file.url}, type: file.type, thumb: file.thumb ? file.thumb : file.url});
                });

                console.log(this.files);
            });

            if (this.word.oral) {
                this.audioUrl = 'data:audio/wav;base64,' + this.word.oral;
                this.audioString = this.word.oral;
            }

        } else {

            this.wordForm = new FormGroup({
                wordWritten: new FormControl(''),
            });

            this.mainFile = {exist: false, element: {}, type: 'image', thumb: null};
        }
    }

    onClickFileZone(indexPicture) {

        if (indexPicture === 0 || this.mainFile.thumb === '' || this.mainFile.type === '') {
            this.showTabs = 0;
            this.exploreMainPicture = true;
        } else {
            this.showTabs = indexPicture;
            this.exploreMainPicture = false;
        }
    }

    uploadFile(event) {

        if (this.exploreMainPicture) {

            const file = event[0];
            const extension = file.name.substr( file.name.lastIndexOf('.') + 1).toLowerCase();

            if (file.size >= 5120000) {
                alert('L\'image est trop lourde! 1 Mo maximum.');
                return;
            }

            if (extension !== 'jpg' && extension !== 'png' && extension !== 'jpeg') {
                alert('L\'image doit être au format JPG ou PNG');
                return;
            }

            const reader = new FileReader();
            reader.onload = e => {

                this.mainFile = {exist: false, element: file, type: 'image', thumb: reader.result as string};
                this.exploreMainPicture = false;
                this.showTabs = -1;
                this.explorerTab = '';
            }

            reader.readAsDataURL(file);

            // Getting EXIF data to get orientation
            const fileReader = new FileReader();
            fileReader.addEventListener('load', fileReaderEvent => {
                const data = EXIF.readFromBinaryFile(fileReader.result);
                if (data && data.Orientation) {
                    this.imageOrientation = data.Orientation;
                }
            });
            fileReader.readAsArrayBuffer(file);

        } else {
            for (let index = 0; index < event.length; index++) {
                const element = event[index];

                if (element.size >= 1024000) {
                    alert("L'image est trop lourde! 1 Mo maximum.");
                    return;
                }

                const reader = new FileReader();
                reader.onload = e => {
                    this.files.push({exist: false, element: element, type: 'image', thumb: reader.result as string});
                    this.showTabs = -1;
                    this.explorerTab = '';
                }

                reader.readAsDataURL(element);
            }
        }
    }

    deleteAttachment(index) {
        this.files.splice(index, 1)
    }


    showExplorerTab(tab) {
        if (tab !== this.explorerTab) {
            this.explorerTab = tab;

            if (tab == 'add') { //if Add tab is opened, we launch the image search
              this.searchImage();
            }
        } else {
            this.explorerTab = '';
        }
    }

    searchImage() {

        const search = this.searchField.nativeElement.value;

        this.searchResults = [];

        if (this.activateLexibox) {
          this.searchLexibox.getByName(this.patientId, search).pipe(first()).subscribe(results => {
              (results as any[]).reverse();
              (results as any).forEach((icon) => {
                  this.searchResults.push({name: icon.name, source: 'lexibox', picture: this.apiUrl + '/attachments/files/download/' + icon.picture, thumbnail: icon.thumbnail ? this.apiUrl + '/attachments/files/download/' + icon.thumbnail : null });
              });
          });
        }

        if (search.length < 3)
            return;

        if (this.activateIcons8) {
          this.http.get(`https://search.icons8.com/api/iconsets/v4/search?term=${search}&amount=60&offset=0&platform=ios7&language=fr-FR&token=b1BnrIXnhGfyiQxcj3Vdh`).pipe(first()).subscribe(results => {
              (results as any).icons.forEach((icon) => {
                this.searchResults.push({name: icon.name, source: 'icons8', picture: `http://img.icons8.com/ios7/${icon.commonName}.svg?token=b1BnrIXnhGfyiQxcj3Vdh`});
              });
          });
        }

        if (this.activatePixabay) {
          this.http.get(`https://pixabay.com/api/?key=11424326-83714d5286aafd125102176f9&per_page=40&q=${search}&lang=fr`).pipe(first()).subscribe(results => {
              (results as any).hits.forEach((icon) => {
                this.searchResults.push({name: icon.name, source: 'pixabay', picture: icon.webformatURL });
              });
          });
        }


    }

    dataURItoBlob(dataURI) {
        // convert base64/URLEncoded data component to raw binary data held in a string
        let byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0) {
            byteString = atob(dataURI.split(',')[1]);
        } else {
            byteString = unescape(dataURI.split(',')[1]);
        }

        // separate out the mime component
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
        const ia = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ia], {type: mimeString});
    }

    selectPicture(picture) {

        // todo improve pciture url
        const thumb = picture.thumbnail ? picture.thumbnail : picture.picture;
        picture.url = picture.picture;

        if (picture.source === 'pixabay') {
            const img = new Image();
            img.setAttribute('crossOrigin', 'anonymous');

            const this2 = this;
            img.onload = function() {
                const canvas = document.createElement("canvas") as any;
                canvas.width = (this as any).width;
                canvas.height = (this as any).height;

                const ctx = canvas.getContext('2d');
                ctx.drawImage(this, 0, 0);

                const dataURL = canvas.toDataURL('image/png');
                const blob = this2.dataURItoBlob(dataURL);

                const newPicture = {exist: false, element: blob, type: 'image', thumb: dataURL};
                
                if (this2.exploreMainPicture) {
                    this2.mainFile = newPicture;
                } else {
                    this2.files.push(newPicture);
                }
            };

            img.src = picture.picture;
        } else {
            const newPicture = {exist: true, element: picture, type: 'image', thumb};

        if (this.exploreMainPicture) {
                this.mainFile = newPicture;
        } else {
                this.files.push(newPicture);
            }
        }


        this.showTabs = -1;
        this.explorerTab = '';
    }



    takePicture(event: Event): void {
        if ((event.target as HTMLInputElement).files && (event.target as HTMLInputElement).files[0]) {
            const file = (event.target as HTMLInputElement).files[0];

            this.ngxPicaService.resizeImage(file, 1200, 1200, {aspectRatio: {keepAspectRatio: true}})
                .subscribe((imageResized: File) => {

                    this.ngxPicaService.resizeImage(file, 350, 350, {aspectRatio: {keepAspectRatio: true}})
                        .subscribe((thumbResized: File) => {
                            let reader: FileReader = new FileReader();

                            reader.addEventListener('load', (event: any) => {

                                if (this.exploreMainPicture) {
                                    this.mainFile = {exist: false, element: imageResized, type: 'image', thumb: (reader.result  as string)};
                                } else {
                                    this.files.push({exist: false, element: imageResized, type: 'image', thumb: (reader.result  as string)});
                                }

                            }, false);

                            reader.readAsDataURL(thumbResized);

                        }, (err: NgxPicaErrorInterface) => {
                            throw err.err;
                        });

                }, (err: NgxPicaErrorInterface) => {
                    throw err.err;
                });
        }
    }

    async importFile() {

        const url = this.importInput.nativeElement.value;
        if (this.getYoutubeId(url)) {
            const data = this.getYoutubeId(url);
            this.files.push({exist: true, element: {url: data.url}, type: 'video', thumb: data.thumbnail});
        } else if (this.getDailyMotionId(url)) {
            const data = this.getDailyMotionId(url);
            this.files.push({exist: true, element: {url: data.url}, type: 'video', thumb: data.thumbnail});
        } else if (await this.getVimeoId(url)) {
            const data = await this.getVimeoId(url);
            this.files.push({exist: true, element: {url: data.url}, type: 'video', thumb: data.thumbnail});
        } else if (url.match(/\.(jpeg|jpg|gif|png)$/) != null) {
            this.files.push({exist: true, element: {url: url}, type: 'image', thumb: url});
        } else {
            alert("L'import de vidéos nest pas encore suporté");
        }

        this.showTabs = -1;
        this.explorerTab = '';

        this.importInput.nativeElement.value = '';
    }

    getYoutubeId(url) {

        const r = url.match(/^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/);

        if (!r) {
            return null;
        } else {
            return {
                url: 'https://www.youtube.com/embed/' + r[1],
                thumbnail: 'https://i3.ytimg.com/vi/' + r[1] + '/hqdefault.jpg'
            };
        }
    }

    getDailyMotionId(url) {

        const r = url.match(/^.+dailymotion.com\/(video|hub)\/([^_]+)[^#]*(#video=([^_&]+))?/);
        if (r) {
            if (r[4]) {
                return {
                    url: 'https://www.dailymotion.com/embed/video/' + r[4],
                    thumbnail: 'https://www.dailymotion.com/thumbnail/video/' + r[4]
                };
            }
            return {
                url: 'https://www.dailymotion.com/embed/video/' + r[2],
                thumbnail: 'https://www.dailymotion.com/thumbnail/video/' + r[2]
            };
        }
        return null;
    }

    async getVimeoId(url) {

        const r = url.match(/^.+vimeo.com\/(\d+)($|\/)/);
        if (!r) {
            return null;
        } else {
            const videoData = await this.http.get(`http://vimeo.com/api/v2/video/${r[1]}.json`)
                .toPromise();

            return {
                url: 'https://player.vimeo.com/video/' + r[1],
                thumbnail: (videoData[0] as any).thumbnail_medium
            };
        }
    }

    onClickSubmit() {
        if (!this.wordForm.value.wordWritten) {
            alert('Vous devez donner un nom au mot');
            return;
        }

        if (!this.mainFile.thumb || this.mainFile.thumb === '') {
            alert('Vous devez choisir une image');
            return;
        }

        this.uploading = true;

        if (!this.word) {

            const word = new Word({});
            word.name = this.wordForm.value.wordWritten;
            word.patientId = getCurrentAbeille().id;
            if (this.mainFile.exist) {
                word.fileName = (this.mainFile.element as any).picture;
            }

            word.oral = this.audioString;

            if (this.category) {
                this.wordService.registerByCategoryId(this.category.id, word).pipe(first()).subscribe(word => {

                    if (!this.mainFile.exist) {
                        this.uploadMainFile(word);
                    }
                    this.uploadAdditionFiles(word);
                });
            } else if (this.subCategory) {
                this.wordService.registerBySubCategoryId(this.subCategory.id, word).pipe(first()).subscribe(word => {

                    if (!this.mainFile.exist) {
                        this.uploadMainFile(word);
                    }
                    this.uploadAdditionFiles(word);
                });
            } else if (this.intercalaireId) {
                this.wordService.registerByIntercalaireId(this.intercalaireId, word).pipe(first()).subscribe(word => {

                    if (!this.mainFile.exist) {
                        this.uploadMainFile(word);
                    }
                    this.uploadAdditionFiles(word);
                });
            }

        } else {

            this.word.name = this.wordForm.value.wordWritten;
            if (this.mainFile.exist) {
                this.word.fileName = (this.mainFile.element as any).picture;
            }

            this.word.oral = this.audioString;

            this.wordService.update(this.word).pipe(first()).subscribe(res => {

                this.wordService.deleteAdditionalFiles(this.word.id).pipe(first()).subscribe(res => {

                    if (!this.mainFile.exist) {
                        this.uploadMainFile(this.word);
                    }

                    this.uploadAdditionFiles(this.word);
                });
            });
        }
    }

    uploadMainFile(word) {
        this.lexiboxService.uploadFile( this.mainFile.element ).pipe(first()).subscribe(file => {
            const fileName = file['result']['files']['stoveImage'][0]['name'];
            word.fileName = this.apiUrl + '/attachments/files/download/' + fileName;
            this.wordService.update(word).pipe(first()).subscribe(file => {
                this.refreshEvent.next();
            });
        });
    }


    uploadAdditionFiles(word) {

        if (this.currentDownloadingFile === this.files.length) {
            this.wordForm.reset();
            this.mainFile = {exist: false, element: {}, type: '', thumb: ''};
            this.files = [];
            this.currentDownloadingFile = 0;
            this.wordForm.reset();
            this.refreshEvent.next();
            this.uploading = false;
            this.deleteAudio();

            return;
        }

        if (this.files[this.currentDownloadingFile].exist) {

            this.linkFileToWord(word,
                (this.files[this.currentDownloadingFile].element as any).url,
                this.files[this.currentDownloadingFile].type,
                this.files[this.currentDownloadingFile].thumb
            );
        } else {
            this.lexiboxService.uploadFile( this.files[this.currentDownloadingFile].element ).pipe(first()).subscribe(file => {
                let fileName = file['result']['files']['stoveImage'][0]['name'];

                // todo improve picture url
                fileName = this.apiUrl + '/attachments/files/download/' + fileName;
                this.linkFileToWord(word,
                    fileName,
                    this.files[this.currentDownloadingFile].type);
            });
        }
    }

    linkFileToWord(word, url, type, thumb?) {
        this.wordService.assignAdditionalFile(word.id, url, type, thumb).pipe(first()).subscribe(file => {
            this.currentDownloadingFile++;
            this.uploadAdditionFiles(word);
        });
    }

    recordAudio() {
        return new Promise(async resolve => {
            const stream = await navigator.mediaDevices.getUserMedia({audio: true});
            // @ts-ignore
            const mediaRecorder = new MediaRecorder(stream);
            const audioChunks = [];

            mediaRecorder.addEventListener('dataavailable', event => {
                audioChunks.push(event.data);
            });

            const start = () => mediaRecorder.start();

            const stop = () =>
                new Promise(resolve => {
                    mediaRecorder.addEventListener("stop", () => {
                        console.log(audioChunks);
                        this.audioBlob = new Blob(audioChunks);
                        this.audioUrl = URL.createObjectURL(this.audioBlob);

                        const reader = new FileReader();
                        reader.readAsDataURL(this.audioBlob);
                        reader.onload = () => {
                            this.audioString = (reader.result as any).split(',')[1];
                        };
                    });

                    mediaRecorder.stop();
                });

            resolve({start, stop});
        });
    }

    playAudio() {
        const audio = new Audio(this.audioUrl);
        audio.play();
    }

    deleteAudio() {
        this.audioUrl = '';
        this.audioString = '';
        this.audioBlob = null;
    }

    sleep = time => new Promise(resolve => setTimeout(resolve, time));

    async handleAction() {
        const recorder = await this.recordAudio();
        const actionButton = document.getElementById('action');
        // @ts-ignore
        recorder.start();
        this.isRecording = true;
        await this.sleep(3000);
        this.isRecording = false;
        // @ts-ignore
        await recorder.stop();
    }
}
